import { IconButton } from '@mui/material';
import React from 'react';

const PrimaryIconButton = ({ children, sx, onClick, disabled, ...props }) => {
  return (
    <IconButton
      sx={{
        color: 'white',
        bgcolor: 'rgba(94, 196, 172, 1)',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        '&:hover': {
          bgcolor: 'rgba(94, 196, 172, 0.8)',
        },
        '&:disabled': {
          color: 'white',
          bgcolor: 'rgba(0, 0, 0, 0.2)',
          boxShadow: 'none',
        },
        ...sx,
      }}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </IconButton>
  );
};

export default PrimaryIconButton;
